import { createFileRoute } from "@tanstack/react-router";
import { canonicalLink, pathFromMatch, routeMeta } from "@/lib/seo";
import { cityHeadScripts } from "@/lib/cityJsonLd";
import { CityHomePage } from "@/components/CityHomePage";
import hero from "@/assets/original/hero-shade.jpg";

export const Route = createFileRoute("/spring-branch")({
  head: (ctx) => ({
    links: [canonicalLink(pathFromMatch(ctx))],
    meta: routeMeta(ctx, {
      title: "Custom Awnings, Covers & Shade in Spring Branch, TX | Texas Made Shade",
      description: "Custom welded awnings, sail shades, patio & pergola covers, marine canvas and aluminum fabrication for Spring Branch & Comal County.",
      image: hero,
      socialTitle: "Custom Awnings & Shade — Spring Branch, TX",
      socialDescription: "Welded aluminum + Sunbrella canvas. Custom shade, covers and fabrication serving Spring Branch and Comal County.",
      keywords: "awnings Spring Branch, awning company Spring Branch, custom awnings Spring Branch, sail shades Spring Branch, patio covers Spring Branch, pergola covers Spring Branch, metal awnings Spring Branch, canvas awnings Spring Branch, Texas Made Shade",
    }),
    scripts: cityHeadScripts("Spring Branch", "Comal County"),
  }),
  component: () => <CityHomePage city="Spring Branch" region="Comal County" />,
});
